const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof roles_permissions_emrge_main !== "undefined") return resolve();
	__webpack_require__.l("https://roles-permissions-1054217893522.us-central1.run.app/remoteEntry.js", (event) => {
		if(typeof roles_permissions_emrge_main !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "roles_permissions_emrge_main");
}).then(() => (roles_permissions_emrge_main));